import React, { useContext } from 'react';
import SubscriptionValidation from '../Subscription/SubscriptionValidation/SubscriptionValidation';
import StatisticsStoreMenu from '../StatisticsStoreMenu/StatisticsStoreMenu';
import LinkRenderer from '../LinkRenderer/LinkRenderer';
import { renderNavMenuItems } from '../../utils/subscriptionHelper';
import { APIWebstoreContext } from '../../context/globalContext';
import { Field, LinkFieldValue, WithSitecoreContextProps } from '@sitecore-jss/sitecore-jss-react';
import { SubscriptionRoleFieldsProps } from '../Login/Login';
import nextId from 'react-id-generator';

export type MenuLinkFieldProps = {
  Link: Field<LinkFieldValue>;
  Id?: Field<string>;
  Roles: Array<SubscriptionRoleFieldsProps>;
};

export type MenuFieldsProps = {
  fields: MenuLinkFieldProps;
  displayName: string;
};

export type SecondaryHeaderMenuProps = WithSitecoreContextProps & {
  fields: {
    items: Array<MenuFieldsProps>;
  };
};

const SecondaryHeaderMenu = ({ fields }: SecondaryHeaderMenuProps): React.JSX.Element => {
  const { state } = useContext(APIWebstoreContext);

  if (fields) {
    const menuItems = renderNavMenuItems(fields.items, state);

    return (
      <div className="secondary-menu-div">
        <div className="secondaryheadermenu">
          <div className="secondarymenu">
            <nav>
              {menuItems &&
                menuItems?.map((item: MenuFieldsProps, id: number) => {
                  return item.displayName.toLocaleLowerCase() === 'statisticsstore' ? (
                    <StatisticsStoreMenu isMobile={false} key={nextId()} />
                  ) : item.displayName.toLocaleLowerCase() === 'subscriptionlibrary' ? (
                    <SubscriptionValidation isMobile={false} key={nextId()} />
                  ) : (
                    <div key={nextId()}>
                      <LinkRenderer
                        key={id}
                        fields={{
                          Link: item.fields.Link,
                        }}
                      />
                    </div>
                  );
                })}
            </nav>
          </div>
        </div>
      </div>
    );
  }
  return <></>;
};

export default SecondaryHeaderMenu;
